import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-article',
  templateUrl: 'article.html',
})
export class ArticlePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ArticlePage');
  }

  public doAddArticle() {
    console.dir("doAddArticle()");
  };
}


// WEBPACK FOOTER //
// ./src/pages/article/article.ts